import { AnimatePresence, motion } from "framer-motion";
import AchievementIcon from "@/components/icons/AchievementIcon";

type Props = {
    visible: boolean;
    onClick?: () => void;
    className?: string;
};

const ripples = [
    { delay: 0.25, startOpacity: 0.35, endScale: 2.8, duration: 0.55 },
    { delay: 0.4, startOpacity: 0.25, endScale: 3.2, duration: 0.6 },
    { delay: 0.55, startOpacity: 0.15, endScale: 4.6, duration: 0.65 },
];

export function AchievementBadge({ visible, onClick, className }: Props) {
    return (
        <div
            className={className}
            style={{
                position: "relative",
                width: 36,
                height: 36,
            }}
        >
            <AnimatePresence>
                {visible && (
                    <>
                        {/* Ripple circles */}
                        {ripples.map((ripple, i) => (
                            <motion.div
                                key={`ripple-${i}`}
                                initial={{ scale: 1, opacity: ripple.startOpacity }}
                                animate={{ scale: ripple.endScale, opacity: 0 }}
                                exit={{ opacity: 0 }}
                                transition={{
                                    delay: ripple.delay,
                                    duration: ripple.duration,
                                    ease: "easeOut",
                                }}
                                className="pointer-events-none absolute inset-0 rounded-full bg-[#FFB700]"
                            />
                        ))}

                        {/* Base circle button */}
                        <motion.button
                            key="base-circle"
                            onClick={onClick}
                            initial={{ scale: 0 }}
                            animate={{ scale: 1 }}
                            exit={{ scale: 0, opacity: 0 }}
                            transition={{
                                type: "spring",
                                stiffness: 350,
                                damping: 15,
                                mass: 0.8,
                            }}
                            className="absolute inset-0 flex cursor-pointer items-center justify-center rounded-full border-[0.75px] border-gray-500/15 bg-[#FFB700] shadow-[0_2px_4px_0_rgba(0,0,0,0.15)] backdrop-blur-[4px]"
                        >
                            {/* Trophy icon */}
                            <motion.div
                                initial={{ scale: 0, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                transition={{
                                    delay: 0.3,
                                    type: "spring",
                                    stiffness: 250,
                                    damping: 12,
                                }}
                            >
                                <AchievementIcon width={18} height={18} className="text-[#803800]" />
                            </motion.div>
                        </motion.button>
                    </>
                )}
            </AnimatePresence>
        </div>
    );
}

export default AchievementBadge;
